import React, { useEffect } from 'react'
import Header from '../Header/header'
import "./hero.css"
import star from '../../images/star.svg'
import { ReactComponent as ClutchSVG } from '../../images/Rating.svg';
// import { ReactComponent as HeroSVG } from '../../images/heroimage-min.png'
import rightarrow from '../../images/arrow right.svg'
import Clslider from "../clients-slider/cslider"
import AOS from 'aos';
import heroimg from '../../images/heroimage.webp'
import 'aos/dist/aos.css'; // Import AOS styles

const Hero = () => {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, [])
    return (
        <section className='hero-main'>
            <Header />
            <div className="hero-inner">
                <div className="left" data-aos="fade-up" data-aos-duration="1000">
                    <div className="orange-rated">
                        <img src={star} alt="rate star image" className="star" />
                        <p>5.0 Rated on</p>
                        &nbsp;
                        &nbsp;
                        <ClutchSVG />
                    </div>
                    <h1>Crafting Tomorrow's Digital Experiences</h1>
                    <p>With our niche-specific expertise and proven track record, Our talents  collaborated with global brands to deliver outstanding results and innovative solutions.</p>
                    <a href="https://arttteo.com/contact">
                        <button className="estimation-button">
                            <p>Get your estimation</p>
                            <div className="arrow-circle">
                                <img src={rightarrow} alt="right arrow image" />
                            </div>
                        </button>
                    </a>
                </div>
                <div className="right" data-aos="fade-up" data-aos-duration="2000">
                    <img src={heroimg} alt='heroimage'/>
                </div>
            </div>
            <Clslider />
        </section>
    )
}

export default Hero